import ADataTableBodyServices from './index.vue';

ADataTableBodyServices.install = app => {
  app.component(ADataTableBodyServices.name, ADataTableBodyServices);
};

export default ADataTableBodyServices;
